module.exports = __webpack_public_path__ + "img/mini-005.17a61340.jpg";